/**
 * @generated SignedSource<<bb57ab2024c5ce7649fc3cebe97c22b9>>
 * @relayHash 79208f80c9ecdc05161f40100b23cb62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d252ad31b1b8c1f1098d7603dbfc39e6770eb636e2aeae8641c775d4acee2be

import type { ConcreteRequest, Query } from 'relay-runtime';
export type canProductUserUpgradeAndPayQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type canProductUserUpgradeAndPayQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly isAvailableToUser: boolean;
          } | null | undefined;
        } | null | undefined;
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount: {
          readonly experienceCapabilities: {
            readonly addPaymentMethodV2: {
              readonly isAvailableToUser: boolean;
            } | null | undefined;
          } | null | undefined;
          readonly isCurrentUserBillingAdmin: boolean;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type canProductUserUpgradeAndPayQuery = {
  response: canProductUserUpgradeAndPayQuery$data;
  variables: canProductUserUpgradeAndPayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v4 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v5 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = [
  (v6/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "canProductUserUpgradeAndPayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v3/*: any*/),
                        "action": "THROW",
                        "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "addPaymentMethodV2",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v4/*: any*/),
                                "action": "THROW",
                                "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.experienceCapabilities.addPaymentMethodV2.isAvailableToUser"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v4/*: any*/),
                            "action": "THROW",
                            "path": "tenantContexts.entitlementInfo.entitlement.experienceCapabilities.changeOfferingV2.isAvailableToUser"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "canProductUserUpgradeAndPayQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "experienceCapabilities",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "addPaymentMethodV2",
                            "plural": false,
                            "selections": (v7/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "subscription",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "accountDetails",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "invoiceGroup",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "CcpInvoiceGroup"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v9/*: any*/),
                        "type": "CcpSubscription"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  },
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2d252ad31b1b8c1f1098d7603dbfc39e6770eb636e2aeae8641c775d4acee2be",
    "metadata": {},
    "name": "canProductUserUpgradeAndPayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d2163f8240f8baa0d41d328d213f1983";

export default node;
